import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormControl, Validators, UntypedFormGroup } from '@angular/forms';

import { InspectionSection, Inspection } from '../../shared/models/index';

@Component({
    selector: 'inspectionSection-edit',
    templateUrl: './edit.component.html',
    standalone: false
})
export class InspectionSectionEditComponent implements OnInit {
  @Input() public inspectionSection: InspectionSection;
  @Input() public processing;
  @Output() public toggleSaveInspectionSection: EventEmitter<any> = new EventEmitter();
  @Output() public toggleCancel: EventEmitter<any> = new EventEmitter();
  inspection: Inspection;

  editForm: UntypedFormGroup;
  constructor() {}

  ngOnInit(): void {
    this.initForm();
    this.inspection = this.inspectionSection.inspection;
  }

  public updateInspectionSection(model: any) {
    this.inspectionSection.name = model.name;
    this.inspectionSection.description = model.description;
    this.toggleSaveInspectionSection.emit(this.inspectionSection);
  }

  public cancel() {
    this.toggleCancel.emit();
  }

  initForm() {
    this.editForm = new UntypedFormGroup({
      name: new UntypedFormControl(this.inspectionSection.name, Validators.required),
      description: new UntypedFormControl(this.inspectionSection != null ? this.inspectionSection.description : '')
    });
  }
}
